<coin-v2-dialog-frame [header]="'shared.search-employee-dialog.title' | translate">
  <div class="body-container">
    <p>
      {{ 'shared.search-employee-dialog.msg' | translate }}
    </p>
    @if (formGroup.value.employee) {
      <div class="employee-preview-container">
        <coin-siemens-energy-employee-preview
          [employee]="$any(formGroup.value.employee)"></coin-siemens-energy-employee-preview>
        <button
          mat-flat-button
          (click)="onRemoveButtonClick()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    } @else {
      @if (employees$ | async; as employees) {
        <coin-v2-search-box
          icon="person_search"
          class="larger"
          [placeholder]="'shared.search-employee-dialog.search-placeholder' | translate"
          [formControl]="formGroup.controls.employee"
          [loading]="employees.loading"
          (search)="employeeSearch$.next($event)">
          @for (employee of employees.latestValue; track employee) {
            <ng-template [coinValue]="employee">
              <div class="preview-container">
                <coin-siemens-energy-employee-preview [employee]="employee"></coin-siemens-energy-employee-preview>
              </div>
            </ng-template>
          }
        </coin-v2-search-box>
      }
    }
    <ng-template #search>
      @if (employees$ | async; as employees) {
        <coin-v2-search-box
          icon="person_search"
          class="larger"
          [placeholder]="'shared.search-employee-dialog.search-placeholder' | translate"
          [formControl]="formGroup.controls.employee"
          [loading]="employees.loading"
          (search)="employeeSearch$.next($event)">
          @for (employee of employees.latestValue; track employee) {
            <ng-template [coinValue]="employee">
              <div class="preview-container">
                <coin-siemens-energy-employee-preview [employee]="employee"></coin-siemens-energy-employee-preview>
              </div>
            </ng-template>
          }
        </coin-v2-search-box>
      }
    </ng-template>

    <div class="spacer"></div>

    <coin-v2-dialog-footer
      padding="none"
      color="white">
      <coin-v2-button
        type="secondary"
        [text]="'general.btnCancel' | translate"
        (click)="dialogRef.close()"></coin-v2-button>
      <coin-v2-button
        type="primary"
        [disabled]="!formGroup.valid"
        [text]="'Confirm'"
        (click)="confirm()"></coin-v2-button>
    </coin-v2-dialog-footer>
  </div>
</coin-v2-dialog-frame>
